module.exports = __webpack_public_path__ + "img/aqxx_xz.4e59fd2d.png";